import React from "react";
import ReactApexChart from "react-apexcharts";
 import { useTranslation } from "react-i18next";

export const ProjectCharts = ({ type, data }) => {
   const { t } = useTranslation();

  const { timeSeries, label } = (() => {
    const sources = {
      MSI: ["NDVI", "NDWI", "NDMI", "NDRE", "CIG", "CIRedEdge"],
      SAR: ["RVI"],
      Weather: [
        "Temperature_Air_2m_Min_24h",
        "Temperature_Air_2m_Max_24h",
        "Precipitation_Flux",
        "Wind_Speed_10m_Mean",
        "Relative_Humidity_2m_06h",
        "Solar_Radiation_Flux",
      ],
    };

    const indiceOptions = {
      MSI: [
        { label: "NDVI", value: "NDVI" },
        { label: "NDMI", value: "NDMI" },
        { label: "NDRE", value: "NDRE" },
        { label: "NDWI", value: "NDWI" },
        { label: "CIG", value: "CIG" },
        { label: "CIRedEdge", value: "CIRedEdge" },
      ],
      SAR: [{ label: "RVI", value: "RVI" }],
      Weather: [
        { label: "Min Temperature", value: "Temperature_Air_2m_Min_24h" },
        { label: "Max Temperature", value: "Temperature_Air_2m_Max_24h" },
        { label: "Precipitation", value: "Precipitation_Flux" },
        { label: "Wind Speed", value: "Wind_Speed_10m_Mean" },
        { label: "Relative Humidity", value: "Relative_Humidity_2m_06h" },
        { label: "Solar Radiation", value: "Solar_Radiation_Flux" },
      ],
    };

    let resolvedType = type;
    let resolvedLabel = "";

    outer: for (const [group, options] of Object.entries(indiceOptions)) {
      for (const opt of options) {
        if (opt.value === type || opt.label === type) {
          resolvedType = opt.value;
          resolvedLabel = opt.label;
          break outer;
        }
      }
    }

    for (const [group, types] of Object.entries(sources)) {
      if (types.includes(resolvedType)) {
        const seriesData = data?.data?.[group]?.[resolvedType]?.TIMESERIES;
        if (Array.isArray(seriesData)) {
          const timeSeries = seriesData.map((item) => ({
            x: item.date,
            y: item[`${resolvedType}_MEAN`] ?? null,
          }));
          return { timeSeries, label: resolvedLabel || resolvedType };
        }
      }
    }

    return { timeSeries: [], label: "" };
  })();

 

  const chartOptions = {
    chart: {
      type: "line",
      zoom: {
        enabled: true,
        type: "x",
        autoScaleYaxis: true,
      },
      toolbar: {
        autoSelected: "zoom",
        tools: {
          pan: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          reset: true,
        },
      },
    },
    xaxis: {
      type: "datetime",
      title: {
        // text: "Date",
        text: t("Date"),
      },
    },
    yaxis: {
      title: {
        text: `Value`,
      },
      decimalsInFloat: 2,
    },
    tooltip: {
      x: {
        format: "dd MMM yyyy",
      },
    },
    title: {
      // text: `Time Series`,
      text: t("Time Series"),
      align: "center",
      style: {
        fontSize: "18px",
        fontWeight: "bold",
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    markers: {
      size: 3,
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#00B8D9"],
  };

  const chartSeries = [
    {
      name: `${type} Mean`,
      data: timeSeries,
    },
  ];

  return (
    <div className="card mt-4 p-3 shadow-sm">
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </div>
  );
};
// import React from "react";
// import ReactApexChart from "react-apexcharts";
// import { useTranslation } from "react-i18next";

// export const ProjectCharts = ({ type, data }) => {
//   const { t } = useTranslation();

//   const { timeSeries, label } = (() => {
//     const sources = {
//       MSI: ["NDVI", "NDWI", "NDMI", "NDRE", "CIG", "CIRedEdge"],
//       SAR: ["RVI"],
//       Weather: [
//         "Temperature_Air_2m_Min_24h",
//         "Temperature_Air_2m_Max_24h",
//         "Precipitation_Flux",
//         "Wind_Speed_10m_Mean",
//         "Relative_Humidity_2m_06h",
//         "Solar_Radiation_Flux",
//       ],
//     };

//     // 👉 Labels converted to t()
//     const indiceOptions = {
//       MSI: [
//         { label: t("NDVI"), value: "NDVI" },
//         { label: t("NDMI"), value: "NDMI" },
//         { label: t("NDRE"), value: "NDRE" },
//         { label: t("NDWI"), value: "NDWI" },
//         { label: t("CIG"), value: "CIG" },
//         { label: t("CIRedEdge"), value: "CIRedEdge" },
//       ],
//       SAR: [{ label: t("RVI"), value: "RVI" }],
//       Weather: [
//         { label: t("min_temperature"), value: "Temperature_Air_2m_Min_24h" },
//         { label: t("max_temperature"), value: "Temperature_Air_2m_Max_24h" },
//         { label: t("precipitation"), value: "Precipitation_Flux" },
//         { label: t("wind_speed"), value: "Wind_Speed_10m_Mean" },
//         { label: t("relative_humidity"), value: "Relative_Humidity_2m_06h" },
//         { label: t("solar_radiation"), value: "Solar_Radiation_Flux" },
//       ],
//     };

//     let resolvedType = type;
//     let resolvedLabel = "";

//     outer: for (const [group, options] of Object.entries(indiceOptions)) {
//       for (const opt of options) {
//         if (opt.value === type || opt.label === type) {
//           resolvedType = opt.value;
//           resolvedLabel = opt.label;
//           break outer;
//         }
//       }
//     }

//     for (const [group, types] of Object.entries(sources)) {
//       if (types.includes(resolvedType)) {
//         const seriesData = data?.data?.[group]?.[resolvedType]?.TIMESERIES;

//         if (Array.isArray(seriesData)) {
//           const timeSeries = seriesData.map((item) => ({
//             x: item.date,
//             y: item[`${resolvedType}_MEAN`] ?? null,
//           }));

//           return { timeSeries, label: resolvedLabel || resolvedType };
//         }
//       }
//     }

//     return { timeSeries: [], label: "" };
//   })();

//   const chartOptions = {
//     chart: {
//       type: "line",
//       zoom: {
//         enabled: true,
//         type: "x",
//         autoScaleYaxis: true,
//       },
//       toolbar: {
//         autoSelected: "zoom",
//       },
//     },

//     xaxis: {
//       type: "datetime",
//       title: { text: t("date") },
//     },

//     yaxis: {
//       title: { text: t("value") },
//       decimalsInFloat: 2,
//     },

//     tooltip: {
//       x: { format: "dd MMM yyyy" },
//     },

//     title: {
//       text: t("Time Series"),
//       align: "center",
//       style: { fontSize: "18px", fontWeight: "bold" },
//     },

//     stroke: { curve: "smooth", width: 2 },
//     markers: { size: 3 },
//     dataLabels: { enabled: false },
//     colors: ["#00B8D9"],
//   };

//   const chartSeries = [
//     {
//       name: `${label} ${t("mean")}`,
//       data: timeSeries,
//     },
//   ];

//   return (
//     <div className="card mt-4 p-3 shadow-sm">
//       <ReactApexChart
//         options={chartOptions}
//         series={chartSeries}
//         type="line"
//         height={350}
//       />
//     </div>
//   );
// };

